import React from 'react';

import { LocationInfoHolder } from './location_info_holder';
import { ServerCommunicationUtil } from '../../../../utils/server_communication_util';

const createReactClass = require('create-react-class');

const LocationMergeInterface = createReactClass({
  getInitialState() {
    const countries = this.props.countries.map(function(item) {
      return item.country;
    });
    const states = this.props.states.map(function(item) {
      return item.state;
    });
    let object1 = null;
    let showReset = false;
    let showSecondEntryField = false;
    let allowedTypes = ['area', 'place'];
    if (this.props.initialPark) {
      object1 = this.props.initialPark;
      object1.obj_type = 'parks';
      allowedTypes = ['area'];
      showReset = true;
      showSecondEntryField = true;
    } else if (this.props.initialCity) {
      object1 = this.props.initialCity;
      object1.obj_type = 'cities';
      allowedTypes = ['place'];
      showReset = true;
      showSecondEntryField = true;
    } else if (this.props.initialState) {
      object1 = this.props.initialState;
      object1.obj_type = 'states';
      allowedTypes = ['place'];
      showReset = true;
      showSecondEntryField = true;
    } else if (this.props.initialCountry) {
      object1 = this.props.initialCountry;
      object1.obj_type = 'countries';
      allowedTypes = ['place'];
      showReset = true;
    }
    return {
      object1,
      object2: null,
      allowedTypes,
      showReset,
      showSecondEntryField,
      countries,
      states,
      mergeStatus: null
    };
  },
  containsCatchAllCity() {
    // cities with no name and a '-' slug are catch-alls for the geocoder for trails with no city and should not be merged in either direction
    if (
      (this.state.object2.slug === '-' && this.state.object2.name === null) ||
      (this.state.object1.slug === '-' && this.state.object1.name === null)
    ) {
      return true;
    }
    return false;
  },
  performMerge(e, force = false) {
    let url = '';
    const params = {};
    if (this.containsCatchAllCity()) {
      alert('This city cannot be merged.');
      return;
    }

    if (force || confirm(`Are you sure you want to merge ${this.state.object1.name} into ${this.state.object2.name}?`)) {
      if (force) {
        params.force_merge = force;
      }

      if (this.state.allowedTypes[0] === 'area') {
        url = `/api/alltrails/locations/parks/${this.state.object1.id}/merge`;
        params.park_id_to_merge_into = this.state.object2.id;
      } else if (this.state.allowedTypes[0] === 'place') {
        if (this.state.object1.obj_type == 'cities') {
          url = `/api/alltrails/locations/cities/${this.state.object1.id}/merge`;
          params.city_id_to_merge_into = this.state.object2.id;
        } else if (this.state.object1.obj_type == 'states') {
          url = `/api/alltrails/locations/states/${this.state.object1.id}/merge`;
          params.state_id_to_merge_into = this.state.object2.id;
        }
      }

      ServerCommunicationUtil.postApiEndpoint(
        url,
        params,
        function(data) {
          // prompt again if duplicate cities were found, and retry with force flag on confirmation
          if (data.duplicatedCities && data.duplicatedCities.length > 0) {
            const names = data.duplicatedCities
              .map(function(c) {
                return c.name;
              })
              .join(', ');
            if (
              confirm(
                `Found cities with the same name in both states, do you want to merge these? The following cities in ${this.state.object1.name} will be merged into their counterparts in ${this.state.object2.name}: ${names}.`
              )
            ) {
              this.performMerge(null, true);
            }
          } else {
            this.setState({ mergeStatus: 'Merge queued for processing' });
          }
        }.bind(this),
        function() {
          this.setState({ mergeStatus: 'An error occurred' });
        }.bind(this),
        function() {}
      );
    }
  },
  performSave(object, newLocationObject, params, objectIndex, callback) {
    if (objectIndex === 1) {
      this.setState({ object1: newLocationObject });
    } else {
      this.setState({ object2: newLocationObject });
    }

    if (object.id) {
      ServerCommunicationUtil.putApiEndpoint(
        `/api/alltrails/locations/${object.obj_type}/${object.id}`,
        params,
        function(data) {
          callback(true);
        },
        function() {
          callback(false);
        },
        function() {}
      );
    } else {
      ServerCommunicationUtil.postApiEndpoint(
        `/api/alltrails/locations/${object.obj_type}`,
        params,
        function(data) {
          callback(true, data);
        },
        function() {
          callback(false);
        },
        function() {}
      );
    }

  },
  performDelete(object, params, callback) {
    ServerCommunicationUtil.deleteApiEndpoint(
      `/api/alltrails/locations/${object.obj_type}/${object.id}`,
      params,
      function(data) {
        callback(true);
      },
      function() {
        callback(false);
      },
      function() {}
    );
  },
  switchObjectOrder() {
    const allowedType = this.state.allowedTypes;
    const newObj1 = this.state.object2;
    const newObj2 = this.state.object1;
    this.resetFields();
    this.setState({
      object1: newObj1,
      object2: newObj2,
      showSecondEntryField: true,
      showReset: true,
      allowedTypes: allowedType
    });
  },
  isDuplicateObject(obj) {
    // compare ID's once we know both objects are of the same type (park, city, etc.)
    let isDuplicate = false;
    if (this.state.object1 && this.state.object1.id === obj.ID) {
      isDuplicate = true;
    } else if (this.state.object2 && this.state.object2.id === obj.ID) {
      isDuplicate = true;
    }
    return isDuplicate;
  },
  resetFields() {
    this.setState({
      object1: null,
      object2: null,
      allowedTypes: ['area', 'place'],
      showReset: false,
      mergeStatus: null,
      showSecondEntryField: false
    });
    return false;
  },
  handleObjectSelected(object, index) {
    // reject the Algolia result if user selects wrong kind of location to merge, or if the selection is the same result
    if (
      object.objectID.indexOf('area') === -1 &&
      object.objectID.indexOf('cityo') === -1 &&
      object.objectID.indexOf('state') === -1 &&
      this.state.object1 &&
      index === 2
    ) {
      alert('Please select a city, state or park.');
      return false;
    }
    if (this.isDuplicateObject(object)) {
      alert('Please select two different locations.');
      return false;
    }
    // Don't let a city be merged into a state and vice versa
    if (this.state.object1 && index === 2) {
      if (this.state.object1.obj_type == 'cities' && object.objectID.indexOf('cityo') === -1) {
        alert('Please select a city.');
        return false;
      }
      if (this.state.object1.obj_type == 'states') {
        if (object.objectID.indexOf('state') === -1) {
          alert('Please select a state.');
          return false;
        }
        // url is the only thing present on both objects that has country in consistent format
        if (this.state.object1.url.split('/')[0] != object.slug.split('/')[0]) {
          alert('Please select a state in the same country.');
          return false;
        }
      }
    }

    const { type } = object;
    if (type === 'area') {
      ServerCommunicationUtil.getApiEndpoint(
        '/api/alltrails/locations/parks/',
        { park_id: object.ID },
        function(data) {
          data[0].obj_type = 'parks';
          if (index === 1) {
            this.setState({
              object1: data[0],
              allowedTypes: [type],
              showReset: true,
              mergeStatus: null,
              showSecondEntryField: true
            });
          } else {
            this.setState({ object2: data[0] });
          }
        }.bind(this),
        function() {
          console.log('error');
        },
        function() {}
      );
    } else {
      // if Algolia type is 'place' we need to parse whether the result is a city/state/country
      if (object.objectID.indexOf('state') !== -1) {
        ServerCommunicationUtil.getApiEndpoint(
          '/api/alltrails/locations/states',
          { state_id: object.ID },
          function(data) {
            data[0].obj_type = 'states';
            if (index === 1) {
              this.setState({
                object1: data[0],
                showReset: true,
                showSecondEntryField: true,
                allowedTypes: [type]
              });
            } else {
              this.setState({ object2: data[0] });
            }
          }.bind(this),
          function() {
            console.log('error');
          },
          function() {}
        );
      } else if (object.objectID.indexOf('country') !== -1) {
        ServerCommunicationUtil.getApiEndpoint(
          '/api/alltrails/locations/countries',
          { country_id: object.objectID.split('-')[1] },
          function(data) {
            data[0].obj_type = 'countries';
            if (index === 1) {
              this.setState({
                object1: data[0],
                showReset: true,
                allowedTypes: [type]
              });
            } else {
              this.setState({ object2: data[0] });
            }
          }.bind(this),
          function() {
            console.log('error');
          },
          function() {}
        );
      } else {
        ServerCommunicationUtil.getApiEndpoint(
          '/api/alltrails/locations/cities/',
          { city_id: object.ID },
          function(data) {
            data[0].obj_type = 'cities';
            if (index === 1) {
              var cityNotMergable = data[0].slug === '-' && (data[0].name === null || data[0].name === undefined);
              var mergingStatus = cityNotMergable ? 'This city cannot be merged' : null;
              this.setState({
                object1: data[0],
                allowedTypes: [type],
                showReset: true,
                mergeStatus: mergingStatus,
                showSecondEntryField: true
              });
            } else {
              var cityNotMergable = data[0].slug === '-' && (data[0].name === null || data[0].name === undefined);
              var mergingStatus = cityNotMergable ? 'This city cannot be merged' : null;
              this.setState({
                object2: data[0],
                mergeStatus: mergingStatus
              });
            }
          }.bind(this),
          function() {
            console.log('error');
          },
          function() {}
        );
      }
    }

    event.preventDefault();
    return false;
  },
  toggleAddParkForm(showAddParkForm) {
    const object1 = showAddParkForm ? {
      obj_type: "parks",
      name: "",
      location: {
        latitude: "",
        longitude: ""
      }
    } : null;
    this.setState({
      showAddParkForm,
      object1,
      object2: null,
      showSecondEntryField: false
    });
  },
  render() {
    let secondLocationHolder = null;
    if (this.state.showSecondEntryField) {
      secondLocationHolder = (
        <LocationInfoHolder
          locationObject={this.state.object2}
          handleObjectSelected={this.handleObjectSelected}
          left={false}
          index={2}
          allowedTypes={this.state.allowedTypes}
          countries={this.state.countries}
          states={this.state.states}
          type={this.state.allowedTypes[0]}
          performSave={this.performSave}
          performDelete={this.performDelete}
        />
      );
    }
    let mergeButton = null;
    if (this.state.object1 !== null && this.state.object2 !== null) {
      if (this.state.mergeStatus !== null) {
        mergeButton = (
          <div className="user-info-centered" disabled>
            <div className="btn grey rounded simple" onClick={this.performMerge}>
              MERGE
            </div>
          </div>
        );
      } else {
        mergeButton = (
          <div className="user-info-centered">
            <div className="btn blue rounded simple" onClick={this.performMerge}>
              MERGE
            </div>
          </div>
        );
      }
    }

    let mergeText = null;
    if (this.state.mergeStatus) {
      mergeText = <div className="user-info-centered">{this.state.mergeStatus}</div>;
    }

    let swapButton = null;
    if (this.state.object1 !== null && this.state.object2 !== null) {
      swapButton = (
        <div className="user-info-centered">
          <div className="btn green rounded simple" onClick={this.switchObjectOrder}>
            Switch Order
          </div>
        </div>
      );
    }

    let resetButton = null;
    if (this.state.showReset) {
      resetButton = (
        <div className="user-info-centered">
          <div className="btn brown rounded simple" onClick={this.resetFields}>
            Reset
          </div>
        </div>
      );
    }

    let addCancelParkButton;
    if (this.state.showAddParkForm) {
      addCancelParkButton = (
        <a href="#" onClick={() => this.toggleAddParkForm(false)}>
          Cancel
        </a>
      );
    } else {
      addCancelParkButton = (
        <a href="#" onClick={() => this.toggleAddParkForm(true)}>
          Add new Park
        </a>
      );
    }

    return (
      <div className="edition-details">
        <div className="trail-edit-form">
          <div className="field clear contains-separator">
            <LocationInfoHolder
              locationObject={this.state.object1}
              handleObjectSelected={this.handleObjectSelected}
              left
              index={1}
              allowedTypes={this.state.allowedTypes}
              countries={this.state.countries}
              states={this.state.states}
              type={this.state.allowedTypes[0]}
              performSave={this.performSave}
              performDelete={this.performDelete}
              showAddForm={this.state.showAddParkForm}
            />
            {secondLocationHolder}
          </div>
          {resetButton}
          {swapButton}
          {mergeText}
          {mergeButton}
        </div>
        <div className="add-cancel-links">
          {addCancelParkButton}
        </div>
      </div>
    );
  }
});

export { LocationMergeInterface };
